import React, { useState } from 'react';
import { HomeOutlined, TeamOutlined, FireOutlined, DollarCircleOutlined, SyncOutlined } from '@ant-design/icons';
import HomeData from './HomeData';
import EnrollmentData from './EnrollmentData';
import UsageData from './UsageData';
import MonetizationData from './MonetizationData';
import SyncMonitor from './SyncMonitor';
import styles from './styles/dashboard-tabs.module.scss';

function DashboardTabs({ report, loading, data }) {
    const [activeTab, setActiveTab] = useState('1');

    const tabs = [
        {
            key: '1',
            label: 'Home',
            icon: <HomeOutlined />,
            component: <HomeData report={report} loading={loading} />
        },
        {
            key: '2',
            label: 'Enrollment',
            icon: <TeamOutlined />,
            component: <EnrollmentData report={report} loading={loading} />
        },
        {
            key: '3',
            label: 'Usage',
            icon: <FireOutlined />,
            component: <UsageData report={report} loading={loading} />
        },
        {
            key: '4',
            label: 'Monetization',
            icon: <DollarCircleOutlined />,
            component: <MonetizationData report={report} loading={loading} />
        },
        {
            key: '5',
            label: 'Sync Monitor',
            icon: <SyncOutlined />,
            component: <SyncMonitor data={data} loading={loading} />
        }
    ];

    const activeTabData = tabs.find(tab => tab.key === activeTab);

    return (
        <div className={styles.tabsContainer}>
            <div className={styles.tabsHeader}>
                {tabs.map(tab => (
                    <button
                        key={tab.key}
                        className={`${styles.tab} ${activeTab === tab.key ? styles.active : styles.inactive}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        <span className={styles.tabIcon}>{tab.icon}</span>
                        <span className={styles.tabLabel}>{tab.label}</span>
                    </button>
                ))}
            </div>
            <div className={styles.tabContent}>
                {activeTabData?.component}
            </div>
        </div>
    );
}

export default DashboardTabs;
